<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-header">
            <h5>PARTES INSTITUCIONES SUPERIORES</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-light">
              <i class="fa fa-exclamation"></i> Realice los siguientes pasos
              para el registro masivo a través de la plantilla Excel.
              <a class="btn-link" @click="onPopupAyuda"
                >Ver ejemplo de plantilla Excel.</a
              >
            </div>
            <hr />
            <h6>
              PASO 1: <small><b>DESCARGAR ARCHIVO EXCEL</b></small>
            </h6>
            <div class="row">
              <!-- <div class="col-md-12 text-center">
                <img src="../../assets/plantilla.png" width="100%">
              </div> -->
              <div class="col-md-12 text-center mt-2">
                <button
                  type="button"
                  class="btn btn-outline-success"
                  @click="downloadPlantilla"
                >
                  <i class="fa fa-download"></i> Descargar Plantilla
                </button>
              </div>
            </div>
            <br />
            <div
              class="alert alert-warning"
              role="alert"
              style="background-color:#F96540;color:#000;"
            >
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br />
              Formato oficial del Excel<br /><b
                >Solo utilizar la plantilla de descarga.</b
              >
            </div>
            <hr />
            <h6>
              PASO 2: <small><b>SUBIR ARCHIVO EXCEL</b></small>
            </h6>
            <div class="row pt-3">
              <div class="col-12 col-md-12">
                <label class="mr-1">Seleccione archivo Excel:</label><br />
                <input
                  type="file"
                  id="file"
                  ref="file"
                  class="form-control"
                  accept=".xls,.xlsx"
                  @change="actualizaExcel($event)"
                />
              </div>
              <div class="col-12 col-md-12">
                <label>Carrera:</label>
                <input
                  type="text"
                  placeholder="INGENIERÍA CIVIL"
                  class="form-control"
                  v-model="carrera"
                  required
                  @keyup="carrera = carrera.toUpperCase()"
                />
              </div>
              <div class="col-12 col-md-12">
                <label class="mr-1">Fecha Inscripción:</label><br />
                <input
                  type="date"
                  class="form-control"
                  v-model="fecha_inscripcion"
                  required
                />
              </div>
              <div class="col-12 col-md-12">
                <div class="form-group">
                  <label>Ciclo Académico:</label><br />
                  <input
                    type="text"
                    placeholder="SEMESTRE 1, ANUAL 2, ETC..."
                    class="form-control"
                    v-model="observacion"
                    required
                    @keyup="observacion = observacion.toUpperCase()"
                  />
                </div>
              </div>
            </div>

            <hr />
            <div class="row">
              <div class="col-12 col-md-12 text-right">
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="procesarArchivo"
                >
                  Registrar Parte
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card">
          <div class="card-header">
            <h5>{{ "EMPRESA - " + empresa.emp_razon_social }}</h5>
          </div>
          <div class="card-body">
            <div
              class="alert alert-warning"
              role="alert"
              style="background-color: rgba(248, 214, 43, 0.3);color:#000;"
            >
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br />
              Debe finalizar los partes declarados, si los datos cargados son
              correctos.<br />
              Parte en estado <b>pendiente</b> tiene hasta 48 hrs para realizar
              el <b>alta</b> o <b>baja</b>, después de la fecha de registro. Una
              vez vencido no se tomar en cuenta como una declaración formal.
            </div>
            <p>
              <small><strong>HISTORIAL DE PARTES</strong></small>
            </p>
            <div
              class="table-responsive"
              style="overflow-y:scroll; height:360px;"
            >
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th class="text-center">
                      <small class="font-weight-bold">NRO</small>
                    </th>
                    <th class="text-center">
                      <small class="font-weight-bold">FECHA REGISTRO</small>
                    </th>
                    <th class="text-center">
                      <small class="font-weight-bold">CARRERA</small>
                    </th>
                    <th class="text-center">
                      <small class="font-weight-bold">CICLO ACADÉMICO</small>
                    </th>
                    <th class="text-center">
                      <small class="font-weight-bold">ESTADO</small>
                    </th>
                    <th class="text-center">
                      <small class="font-weight-bold">ACCIONES</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in historial" :key="index">
                    <td class="text-center">
                      <small>{{ index + 1 }}</small>
                    </td>
                    <td class="text-center">
                      <small>{{ getDateTime(item.fecha_reg) }}</small>
                    </td>
                    <td class="text-center">
                      <small>{{ item.carrera }}</small>
                    </td>
                    <td class="text-center">
                      <small>{{ item.observacion }}</small>
                    </td>
                    <td class="text-center">
                      <span
                        v-if="
                          item.estado_proceso == 0 && item.verifica_estado == 1
                        "
                        class="badge badge-warning"
                        >PENDIENTE</span
                      >
                      <span
                        v-if="
                          item.estado_proceso == 0 && item.verifica_estado == 0
                        "
                        class="badge badge-danger"
                        >VENCIDO</span
                      >
                      <span
                        v-if="item.estado_proceso == 1"
                        class="badge badge-success"
                      >
                        FINALIZADO</span
                      >
                    </td>
                    <td class="text-center">
                      <a
                        v-if="
                          item.estado_proceso == 0 && item.verifica_estado == 1
                        "
                        class="btn btn-outline-success btn-sm mr-1"
                        title="Alta de Parte"
                        @click="showModalConfirmar(item)"
                      >
                        <i class="fa fa-check"></i>
                      </a>
                      <a
                        class="btn btn-outline-primary btn-sm mr-1"
                        title="Ver Parte"
                        @click="showModal(item)"
                      >
                        <i class="fa fa-search"></i>
                      </a>
                      <a
                        v-if="
                          item.estado_proceso == 0 && item.verifica_estado == 1
                        "
                        class="btn btn-outline-danger  btn-sm"
                        title="Baja de Parte"
                        @click="bajaParte(item.id_institucion)"
                      >
                        <i class="fa fa-close"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="DETALLE DE PARTES"
      ref="modalDetalles"
      :no-close-on-backdrop="true"
    >
      <!-- <div class="modal-dialog modal-lg"> -->
      <div class="container mb-3">
        <div class="row mb-1">
          <div class="col-md-12">
            <p>
              Detalle de parte registrado en:
              {{ getDateTime(elegido.fecha_reg) }}
            </p>
          </div>
          <div
            class="table-responsive"
            style="overflow-y:scroll; height:560px;"
            v-if="detalles.length > 0"
          >
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-center">
                    <small class="font-weight-bold">NRO</small>
                  </th>
                  <th class="text-center">
                    <small class="font-weight-bold">NOMBRE COMPLETO</small>
                  </th>
                  <th class="text-center">
                    <small class="font-weight-bold">NRO. DOCUMENTO</small>
                  </th>
                  <th class="text-center">
                    <small class="font-weight-bold">FECHA NACIMIENTO</small>
                  </th>
                  <th class="text-center">
                    <small class="font-weight-bold">NACIONALIDAD</small>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td class="text-center">
                    <small>{{ index + 1 }}</small>
                  </td>
                  <td>
                    <small>{{ item.nombres }} {{ item.apellidos }}</small>
                  </td>
                  <td class="text-center">
                    <small>{{ item.nro_documento }}</small>
                  </td>
                  <td class="text-center">
                    <small>{{ getDate(item.fecha_nacimiento) }}</small>
                  </td>
                  <td class="text-center">
                    <small>{{ item.nacionalidad }}</small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-secondary" @click="hideModal">Cerrar</a>
        </div>
      </div>
      <!-- </div> -->
    </b-modal>

    <b-modal
      class="modal fade"
      hide-footer
      title="CONFIRMAR"
      ref="modalConfirmar"
      :no-close-on-backdrop="true"
    >
      <!-- <div class="modal-dialog modal-lg"> -->
      <div class="container mb-3">
        <div class="row mb-1">
          <p>¿Desea confirmar y finalizar el parte declarado?</p>
          <p>
            Tome en cuenta que <strong>los partes finalizados</strong> no se
            pueden modificar ni borrar.
          </p>
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-primary mr-3" @click="confirmar(elegido)"
            ><i class="fa fa-check"></i> Confirmar</a
          >
          <a class="btn btn-outline-secondary" @click="hideModalConfirmar"
            >Cerrar</a
          >
        </div>
      </div>
      <!-- </div> -->
    </b-modal>

    <b-modal
      class="modal fade"
      hide-footer
      title="EJEMPLO DE PLANTILLA EXCEL"
      ref="modalAyuda"
      size="xl"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row">
          <div class="col-12 col-md-12">
            <img src="../../assets/instituciones.png" width="100%" />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-12">
            <p>
              Forma correcta de llenado de datos de la plantilla Excel:<br />
              - Mantener las cabeceras de cada columna.<br />
              - Llenar los campos correspondiente a cada cabecera.
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import FileSaver from "file-saver";

export default {
  name: "PartesInstituciones",
  data() {
    return {
      id_empresa: 0,
      carrera: "",
      fecha_inscripcion: new moment().format("YYYY-MM-DD"),
      observacion: "",
      historial: [],
      detalles: [],
      elegido: {},
      empresa: {},
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    getDate: function(fecha) {
      if (fecha != null && fecha != "") {
        return moment(fecha).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
    getDateTime: function(fecha) {
      if (fecha != null && fecha != "") {
        return moment(fecha).format("DD/MM/YYYY HH:mm:ss");
      } else {
        return "";
      }
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },

    showModal(item) {
      this.elegido = item;
      this.detallePartes(item.id_institucion);
      this.$refs["modalDetalles"].show();
    },
    hideModal() {
      this.elegido = {};
      this.$refs["modalDetalles"].hide();
    },
    showModalConfirmar(item) {
      this.elegido = item;
      this.$refs["modalConfirmar"].show();
    },
    hideModalConfirmar() {
      this.elegido = {};
      this.$refs["modalConfirmar"].hide();
    },
    actualizaExcel() {
      this.file = this.$refs.file.files[0];
    },
    async procesarArchivo() {
      if (this.file == undefined) {
        this.$swal({
          title: "Atención",
          text: "Debe cargar el parte (plantilla excel).",
          type: "warning",
          confirmButtonText: "Aceptar",
        });
        return;
      } else {
        let fileName = this.file.name;
        var ext = fileName.split(".").pop();
        ext = ext.toLowerCase();
        if (ext != "xls" && ext != "xlsx") {
          this.$swal({
            title: "Atención",
            text: "Debe cargar el parte (plantilla excel).",
            type: "warning",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }

      if (this.carrera == "") {
        this.$swal({
          title: "Atención",
          text: "La carrera es obligatoria",
          type: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      // if(this.observacion == ''){
      //   this.$swal({
      //     title: 'Atención',
      //     text: 'Fecha final es obligatoria',
      //     type: 'error',
      //     confirmButtonText: 'Aceptar'
      //   });
      //   return;
      // }

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      let formData = new FormData();
      formData.append("id_empresa", this.id_empresa);
      formData.append("archivo", this.file);
      formData.append("carrera", this.carrera);
      formData.append("observacion", this.observacion);
      formData.append("fecha_inscripcion", this.fecha_inscripcion);

      try {
        let res = await this.axios.post(
          `/subir/partes_instituciones`,
          formData,
          config
        );
        if (res.status === 200) {
          this.cargarHistorial(this.id_empresa);
          this.$swal({
            title: "Información",
            text: "Se subió correctamente el archivo",
            type: "success",
            confirmButtonText: "Aceptar",
          });
          this.Limpiar();
        }
      } catch (error) {
        console.log("catch: ", error);
        this.cargando = false;
      }
    },
    async cargarHistorial(id_empresa) {
      // console.log(" regggg: ",id_empresa);
      this.cargando = true;
      try {
        let res = await this.axios.get(
          `/historialInstitucion/partes/${id_empresa}`
        );
        this.historial = res.data.contenido;

        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
    async detallePartes(id_institucion) {
      this.cargando = true;
      try {
        let res = await this.axios.get(
          `/historialInstitucion/detalle/${id_institucion}`
        );
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },

    async confirmar(item) {
      this.cargando = true;
      try {
        let res = await this.axios.put(
          `/confirmarParteInstitucion/${item.id_institucion}`
        );
        if (res.status === 200) {
          this.cargando = false;
          this.cargarHistorial(this.id_empresa);
          this.hideModalConfirmar();
          this.$swal({
            title: "Información",
            text: "Finalizó correctamente el registro",
            type: "success",
            confirmButtonText: "Aceptar",
          });
        }
      } catch (error) {
        console.log("error ", error);
        this.cargando = false;
      }
    },
    async downloadPlantilla() {
      try {
        let resultados = await this.axios.get("/getPlantillaInstitucion", {
          responseType: "blob",
        });
        if (resultados.status == 200) {
          let file = new Blob([resultados.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          FileSaver.saveAs(file, "plantilla.xlsx");
        }
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    crearDescarga(response, title) {
      if (!response) {
        return false;
      }
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    onChangeFechaIni(event) {
      let fecha = event.target._value;
      document.getElementById("observacion").setAttribute("min", fecha);
    },
    onPopupAyuda() {
      this.$refs["modalAyuda"].show();
    },
    bajaParte(id_institucion) {
      try {
        this.$swal({
          text: "¿Confirma quitar declaración de manifiesto?",
          type: "warning",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            this.axios
              .put(`/bajaParteInstitucion/${id_institucion}`)
              .then(() => {
                this.cargarHistorial(this.empresa.id_empresa);
              });
          }
        });
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    Limpiar() {
      this.file = "";
      this.carrera = "";
      this.observacion = "";
    },
  },
  created() {
    //if(this.$route.params.id_empresa===undefined){
    if (this.$route.params.item === undefined) {
      this.$router.push("Empresas");
    } else {
      //this.id_empresa = this.$route.params.id_empresa;
      this.empresa = this.$route.params.item;
      // console.log('empresa: ',this.empresa);
      this.id_empresa = this.$route.params.item.id_empresa;
      this.cargarHistorial(this.empresa.id_empresa);
    }
  },
};
</script>
